<template>
    <vertical-table v-if="form" :items="computedItems" v-bind="{ itemsPerRow }">
        <template v-for="{ term, type, key, keys, lastKey, props } in computedItems">
            <template v-if="$slots[term]">
                <slot :slot="term" :name="term" />
            </template>
            <template v-else-if="mode == 'view'">
                <template v-if="type == 'images-tile'">
                    <v-images-tile-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" mode="view" />
                </template>
            </template>
            <template v-else-if="mode == 'form'">
                <template v-if="type == 'address'">
                    <v-address-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :btnAttrs="{ color: 'grey-6 white--text', className: 'w-80px w-lg-100px' }" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'currency'">
                    <v-currency-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'date'">
                    <v-date-field v-model="findData(keys)[lastKey]" type="date" max="2999-12-31" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'dates'">
                    <v-row align="center" no-gutters :key="key" :slot="term">
                        <v-col> <v-date-field v-model="findData(keys)[lastKey]['startsAt']" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                        <v-col class="px-10" cols="auto"> ~ </v-col>
                        <v-col> <v-date-field v-model="findData(keys)[lastKey]['endsAt']" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                    </v-row>
                </template>
                <template v-if="type == 'duration'">
                    <v-row align="center" no-gutters :key="key" :slot="term">
                        <v-col> <v-date-field v-model="findData(keys)[lastKey][0]" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                        <v-col class="px-10" cols="auto"> ~ </v-col>
                        <v-col> <v-date-field v-model="findData(keys)[lastKey][1]" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                    </v-row>
                </template>
                <template v-if="type == 'editor'">
                    <naver-smarteditor v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'email'">
                    <v-email-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'file'">
                    <v-file-input v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @change="emit" />
                </template>
                <template v-if="type == 'file-chips'">
                    <v-file-chips v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'hours'">
                    <v-row align="center" no-gutters :key="key" :slot="term">
                        <v-col> <v-time-field v-model="findData(keys)[lastKey]['startsAt']" v-bind="props" @input="emit" /> </v-col>
                        <v-col class="px-10" cols="auto"> ~ </v-col>
                        <v-col> <v-time-field v-model="findData(keys)[lastKey]['endsAt']" v-bind="props" @input="emit" /> </v-col>
                    </v-row>
                </template>
                <template v-if="type == 'images-tile'">
                    <v-images-tile-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @change="emit" />
                </template>
                <template v-if="type == 'password'">
                    <v-password-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'phone'">
                    <v-phone-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'select'">
                    <v-select v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'switch'">
                    <v-switch v-model="findData(keys)[lastKey]" v-bind="props" inset dense hide-details class="pl-4" :key="key" :slot="term" @change="emit" />
                </template>
                <template v-if="type == 'text'">
                    <v-text-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'textarea'">
                    <v-textarea v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
                <template v-if="type == 'username'">
                    <v-username-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" @input="emit" />
                </template>
            </template>
        </template>
    </vertical-table>
</template>

<script>
import VPhoneField from "./v-phone-field.vue";
import VEmailField from "./v-email-field.vue";
import VerticalTable from "./vertical-table.vue";
import VAddressField from "./v-address-field.vue";
import VPasswordField from "../plugins/vuetify/v-password-field.vue";
import NaverSmarteditor from "../plugins/naver/naver-smarteditor.vue";
import VImagesTileField from "../plugins/vuetify/v-images-tile-field.vue";
import VDateField from "../plugins/vuetify/v-date-field.vue";
import VUsernameField from "../plugins/vuetify/v-username-field.vue";
import VFileChips from "../plugins/vuetify/v-file-chips.vue";
import VTimeField from "../plugins/vuetify/v-time-field.vue";

export default {
    components: {
        VPhoneField,
        VEmailField,
        VerticalTable,
        VAddressField,
        VPasswordField,
        NaverSmarteditor,
        VImagesTileField,
        VDateField,
        VUsernameField,
        VFileChips,
        VTimeField,
    },
    props: {
        mode: { type: String, default: "form" },

        value: { type: Object, default: () => ({}) },
        items: { type: Array, default: () => [] },
        itemsPerRow: { type: [Number, String], default: 1 },
    },
    data: () => ({
        form: undefined,
    }),
    computed: {
        computedItems() {
            return this.$props.items.map((item) => {
                let { cols, data, key, message, required, term, type, props__input, ...props } = item;
                if (props__input) props = { ...props, ...props__input };

                let keys = key?.split?.(".") || [];
                let lastKey = keys.pop();
                data = data ?? this.findData(keys)?.[lastKey];

                if (type == "duration") {
                    if (data?.[0] || data?.[1]) {
                        data = `${data[0] ? this.$dayjs(data[0]).format("YYYY.MM.DD. (ddd)") : ""} ~ ${data[1] ? this.$dayjs(data[1]).format("YYYY.MM.DD. (ddd)") : ""}`;
                    } else data = undefined;
                }

                if (type == "currency") {
                    data = data?.format?.() || data;
                    if (data) data += props?.suffix || "";
                }

                let computedItem = { cols, data, key, keys, message, required, lastKey, props, term, type };

                if (this.mode == "form") delete computedItem.data;
                else delete computedItem.required;

                if (this.mode == "view" && type == "images-tile") delete computedItem.data;

                return computedItem;
            });
        },
        slots() {
            return this.$slots;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = { ...this.value };
        },
        emit() {
            this.$emit("input", this.form);
        },
        findData(keys) {
            return keys.reduce((o, key) => o[key], this.form) || this.form;
        },
    },
};
</script>

<style></style>
